import Mock from 'mockjs'

// 登录接口
import login from './modules/login'
Mock.mock(/\/api\/login/, 'post', login.ApiLogin)
// 菜单接口
import menu from './modules/menu'
Mock.mock(/\/api\/menu/, 'post', menu.ApiMenu)
